import React, { Fragment, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TablePagination,
	TableSortLabel, Grid
} from '@material-ui/core/';
import { useRouteMatch } from 'react-router-dom';
import { kebabCase, snakeCase } from 'lodash';

import { displayedHeadersPropType } from 'proptypes/index';
import Row from 'components/SearchableTableV2/Row';
import Filters from 'components/SearchableTableV2/Filters';
import { ErrorAlert } from 'components/Alerts';
import Blocker from 'components/Blocker';
import { sendGetRequest, cancelGetRequest } from '../../utils/api';
import { TableWithFormContext } from 'contexts';
import tableStyle from 'styles/tables';
import { isEmpty } from 'utils/helpers';

const SearchableTable = (props) => {

	const { 
		filters
		, displayRows

		, filterTable
		, filterQuery
		
		, enableFormEdit
		, selectedFormEdit

		, enableRawEdit
		, selectedRawEdit 

		, enableSelect
		, selectedValue
		, queryId
		, useDataRowsFromParent
		, dataRowsFromParent
		, defaultSortColumn
		, keyIdentifier
	} = props;


	const tableClasses = tableStyle();
	const context = useContext(TableWithFormContext);

	const displayedHeaders = props.displayedHeaders
		? props.displayedHeaders
		: context.displayedHeaders;
	const table = props.table ? props.table : context.table;

	const temp = {};

	//Wilbert Comicho
	//May 3, 2021 updated function below to set default values
	
	displayedHeaders.forEach((filterable) => {
		if(filterable.defaultValue)
			temp[filterable.key] = filterable.defaultValue;
		else
			temp[filterable.key] = '';
	});
	

	useEffect(() => {
		console.log("Triggered the displayHeaders and table")
	},[displayedHeaders, table])
	

	const [searchValues, setSearchValues] = useState(temp);

	const { path } = useRouteMatch();
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [page, setPage] = useState(0);
	const [rows, setRows] = useState([]);
	const [query, setQuery] = useState('');
	const [rowCount, setRowCount] = useState(-1);
	const [fetchingData, setFetchingData] = useState(false);
	const [success, setSuccess] = useState(true);
	const [status, setStatus] = useState(null);
	const rowsPerPageOptions = [5, 10, 25];
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState(defaultSortColumn);

	//May 31, 2021
	const [queryParameters, setQueryParameters] = useState({});
	const [rowsToRender, setRowsToRender] = useState([]);
    const [offline, setOffline] = useState(false);
	const [initializeSearch, setInitializeSearch] = useState(false);

	const getTableData = async () => {
		setLocalStorage();
		console.log("GET TABLE DATA: ", table);
		console.log("QUERY: ", query);
		if (useDataRowsFromParent === true) {
			
			setRows(dataRowsFromParent)
			setRowCount(parseInt(dataRowsFromParent.length));
			setRowsPerPage(50)
		}else{
			const path = `${table}?start=${
				page * rowsPerPage
			}&limit=${rowsPerPage}&sort=${snakeCase(orderBy)}&order=${order}${query}`;
	
			setFetchingData(true);
			const res = await sendGetRequest(path);
	
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				setFetchingData(false);
				alert("An error encountered while fetching data from the server.");
				return;
			}
			if(res.data.length === 0){
				alert('No Record(s) found')
			}

			setFetchingData(false);
			
			setRows(res.data);
			setSuccess(true);
			setRowCount(parseInt(res.headers['x-total-count']));
		}
	};


	useEffect(() => {
		console.log("TRIGGERED LOAD...")
		// return () => {
		//  	cancelGetRequest(`${table}`);
		// };
		getLocalStorage();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if(rows.length > 0) {
			const tmpItems = [];
				let index = 0;
				for(const row of rows){
					index++;
					tmpItems.push(
					<Row
						key = { `table_row_${genKey()}_${index || ''}` }
						row = { row }
						displayedHeaders = { displayRows }
						path = { path }
						index = { index }
						
						enableSelect = { enableSelect || false }
						selectedValue = { selectedValue }
						
						enableRawEdit = { enableRawEdit || false}
						selectedRawEdit = { selectedRawEdit }

						enableFormEdit = { enableFormEdit || false} 
						selectedFormEdit = { selectedFormEdit }

						queryParameters = { queryParameters }

						defaultSortColumn = { defaultSortColumn }

						keyIdentifier = { keyIdentifier }
					/>	
					);
				}
				setRowsToRender(tmpItems);
			
		}
	},[rows])

	useEffect(() => {
		console.log("TRIGGERED ATTRIBUTES FOR PAGE ROWS")
		if(dataRowsFromParent){
			
			setRows(dataRowsFromParent)
			setRowCount(parseInt(dataRowsFromParent.length));
			setRowsPerPage(50)
		}
	},[dataRowsFromParent])


	const getFrTableData = async () => {
		if (useDataRowsFromParent === true) {
			setRows(dataRowsFromParent)
			setRowCount(parseInt(dataRowsFromParent.length));
			setRowsPerPage(50)
		}else{
			const path = `/${table}/assignee?start=${
				page * rowsPerPage
			}&limit=${rowsPerPage}&sort=${snakeCase(orderBy)}&order=${order}`;
	
			setFetchingData(true);
			const res = await sendGetRequest(path);
	
			if (res.error) {
				setSuccess(false);
				setStatus(res.error.message);
				setFetchingData(false);
				return;
			}
			console.log("DATA FETCHED FROM THE SERVER: ", res.data)
			setFetchingData(false);
			setRows(res.data);
			setSuccess(true);
			setRowCount(parseInt(res.headers['x-total-count']));
		}
	};


	useEffect(() => {
		
		if(isEmpty(query) === false){
			getTableData();
		}
		if(table === "famas/header"){
			getFrTableData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
		
	}, [page, rowsPerPage, query, order, orderBy]);

	useEffect(() => {
		if(initializeSearch === true){
			search();
			setInitializeSearch(false);
		}
	},[searchValues])

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const search = (e) => {
		if(e)e.preventDefault();

		console.log("SEARCH SEARCH VALUES: ", searchValues)
		let queryString = '';
		if (isEmpty(searchValues)) return setQuery(queryString);
		
		let tmpQueryParams = JSON.parse(JSON.stringify(searchValues));
		setQueryParameters(tmpQueryParams);
		
		Object.keys(searchValues).forEach(
			(searchTerm) =>
				(queryString = searchValues[searchTerm]
					? `${queryString}&${snakeCase(searchTerm)}=${
							searchValues[searchTerm]
					  }`
					: queryString)
		);
		setPage(0);
		setQuery(queryString);
	};



	const sortRows = (key) => {
		if (key === orderBy) {
			setOrder(order === 'asc' ? 'desc' : 'asc');
		} else {
			setOrder('desc');
			setOrderBy(key);
		}
	};
	
	const genKey = () => {
		var d = new Date();
		var n =  d.getTime();
	
		let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	
		let str = '';
		for (let i = 0; i < 4; i++) {
			str += chars.charAt(Math.floor(Math.random() * chars.length));
		}

		str = str + n.toString();
		return str;
	}

	const getLocalStorage = () => {
		console.log("Captured queryId", queryId);
		if (typeof(Storage) !== "undefined" && queryId) {
			if (localStorage[queryId]) {
				const tempDataRows = JSON.parse(localStorage[queryId]);
				const tempSearchValues = JSON.parse(localStorage[`querySearchValues${queryId}`]);
				const tempTimeBefore = JSON.parse(localStorage[`queryDate${queryId}`]);
				const tempTimeNow = (new Date()).getTime().toString();
				
				const timeBefore = Math.floor(parseInt(tempTimeBefore) / 60000);
				const timeNow = Math.floor(parseInt(tempTimeNow) / 60000);

				console.log("TEMP SEARCH VALUES", tempSearchValues);
				console.log(timeBefore);
				console.log(timeNow);

				setSearchValues({...tempSearchValues});
				//console.log(timeNow - timeBefore ? timeBefore : timeNow);
				
				//if( tempDataRows.length > 0 && (((tempTimeNow - tempTimeBefore)/1000)/60)/60 > 1) {
				if( offline === true  && tempDataRows) {	
					setRows(tempDataRows);
				}else{
					setInitializeSearch(true);
				}
					// }else{
					// 	localStorage[queryId] = null;
					// 	localStorage[`querySearchValues${queryId}`] = null;
					// 	localStorage[`queryDate${queryId}`] = null;
					// }
					
				// }else{
				// 	localStorage[queryId] = null;
				// 	localStorage[`querySearchValues${queryId}`] = null;
				// 	localStorage[`queryDate${queryId}`] = null;
				// }
			}
		} 
	}
	
	const setLocalStorage = () => {
		if (typeof(Storage) !== "undefined" && queryId) {
			console.log("utilizing storage");
			localStorage[queryId] = JSON.stringify(rows);
			localStorage[`querySearchValues${queryId}`] = JSON.stringify(searchValues);
			localStorage[`queryDate${queryId}`] = (new Date()).getTime().toString();
			console.log(JSON.parse(localStorage[queryId]));

			
		} 
	}
	
	return (
		<Fragment>
			{!success && <ErrorAlert>Failed: {status}</ErrorAlert>}
			<Blocker open={fetchingData} />

			{filters && (
				<Filters
					
					setSearchValues={setSearchValues}
					filterables= { displayedHeaders }
					searchValues= { searchValues }
					search={ search }
					filterTable = { filterTable }
					filterQuery = { filterQuery }
					queryParameters = { queryParameters }
				/>
			)}

			{ useDataRowsFromParent === false ?
				<TablePagination
				rowsPerPageOptions={rowsPerPageOptions}
				component="div"
				count={rowCount}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				nextIconButtonProps={{ disabled: rows.length < rowsPerPage }}
				/> : 
				<Grid
				container
				direction = "row"
				justifyContent = "flex-end"
				alignItems="flex-start"
				item spacing={3}
				>
					<Grid item>
						<span>Row count: {rowCount}</span>
					</Grid>	
				</Grid>
			}


			<TableContainer className={tableClasses.tableContainer}>
				<Table
					stickyHeader
					className={tableClasses.table}
					size="small"
				>
					<TableHead>
						<TableRow>
							<TableCell className={tableClasses.tableHeadeIcon} />
							{displayRows &&
								displayRows.map((header) => (
									<TableCell
										className={tableClasses.tableHeader}
										style={{
											minWidth:
												header.displayedLength && header.displayedLength * 3,
										}}
										key={`table_header_${kebabCase(header.key)}`}
									>
										<TableSortLabel
											onClick={() => sortRows(header.key)}
											direction={orderBy === header.key ? order : 'desc'}
										>
											{header.displayedHeader}
										</TableSortLabel>
									</TableCell>
								))}
							<TableCell className={tableClasses.tableHeadeIcon} />
						</TableRow>
					</TableHead>
					<TableBody>
						{
							
							rowsToRender
							
						}
					
					</TableBody>
				</Table>
			</TableContainer>
			{ useDataRowsFromParent === false ?
				<TablePagination
					rowsPerPageOptions={rowsPerPageOptions}
					component="div"
					count={rowCount}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
					
				/> : 
				<Grid
				container
				direction="row"
				justifyContent = "flex-end"
				alignItems="flex-start"
				item spacing={3}
				>
					<Grid item>
						<span>Row count: {rowCount}</span>
					</Grid>
					
				</Grid>
				
			}
		</Fragment>
	);
};

SearchableTable.propTypes = {
	displayedHeaders: displayedHeadersPropType,
	filters: PropTypes.bool,
	
};

SearchableTable.defaultProps = {
	filters: true,
};

export default SearchableTable;
